import { $authHost, $host } from ".";
import  { jwtDecode } from "jwt-decode";

export const signin = async (login, password) => {
    try {
        const response = await $host.post('/api/auth/login', { login, password })
        const data = response.data
        localStorage.setItem('token', data.accessToken)
        return jwtDecode(data.accessToken)
    } catch (error) {
        // Удаляем токен при ошибке входа
        localStorage.removeItem('token')
        throw error
    }
}

export const check = async () => {
    try {
        const { data } = await $authHost.get('/api/auth/check')
        localStorage.setItem('token', data.accessToken)
        return jwtDecode(data.accessToken)
    } catch (error) {
        // Если получаем ошибку авторизации, удаляем токен
        if (error.response?.status === 401) {
            localStorage.removeItem('token')
        }
        throw error
    }
}

export const getUsers = async () => {
    try {
        const response = await $authHost.get('/api/user/all')
        return response
    } catch(e) {
        console.error('Ошибка получения пользователей:', e)
        throw e
    }
}
export const getRoles = async () => {
    try{ 
        const response = await $authHost.get('/api/role/all')
        return response
    } catch(e) {
        console.error('Ошибка получения ролей:', e)
        throw e
    }
}
export const addUser = async (user) => {
    try{ 
        const response = await $authHost.post('/api/user/', user)
        return response
    } catch(e) {
        console.error('Ошибка создания пользователя:', e)
        throw e
    }
}
export const addRole = async (user) => {
    try{ 
        const response = await $authHost.post('/api/role/create', user)
        return response
    } catch(e) {
        console.error('Ошибка создания роли:', e)
        throw e
    }
}
export const editUser = async (user) => {
    try {
        const response = await $authHost.post('/api/user/update', user)
        return response
    } catch(e) {
        console.error('Ошибка обновления пользователя:', e)
        throw e
    }
}

export const deleteUser = async (user) => {
    try {
        const response = await $authHost.post('/api/user/delete', user)
        return response
    } catch(e) {
        console.error('Ошибка удаления пользователя:', e)
        throw e
    }
}

